import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import { Home } from "./components/Home";
import { Imprint } from "./components/Imprint";
import { Privacy } from "./components/Privacy";
import { Projects, ProjectDetail } from "./components/ProjectPortfolio";
import { Analytics } from "./components/Analytics";

function Root() {
  return (
    <>
      <Analytics />
      <Outlet />
    </>
  );
}

const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/projects", element: <Projects /> },
      { path: "/projects/:slug", element: <ProjectDetail /> },
      { path: "/imprint", element: <Imprint /> },
      { path: "/privacy", element: <Privacy /> },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
